// extracted by mini-css-extract-plugin
export default {"list":"xO4ZTj","items":"AChrQB"};